$( document ).ready(function() {
    $('.store_message_icon').each(function () {
        let dataSrcVal = $(this).attr('src')
        if(dataSrcVal.indexOf("/no-image-") >= 0){
            $(this).css('display', 'none')
        }
    })
})
